import "./index.css";
import { PAYOUTS_PAYMENTS_NAME } from "../../constants/constans";
import PaymentStatusBox from "../../components/PaymentStatusBox";
import TopItemList from "../../components/TopItemList";
import 'react-date-range-ts/dist/styles.css';
import 'react-date-range-ts/dist/theme/default.css';
import { DateRangePicker } from "react-date-range-ts";
import { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import { useGetTrendingCartsQuery, useGetTrendingRestaurantsQuery, useLazyGetSalesPayoutStatisticsQuery } from "../../redux/services/dashboardService";
import BreadCrumbs from "../../components/BreadCrumbs";
import { Container, Spinner } from "react-bootstrap";

const PaymentDashboard = () => {
  const [openDate, setOpenDate] = useState(false);
  const [date, setDate] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  const [fetchData, { data, isLoading: isLoadingStatistics, isFetching: isFetchingStatistics }] = useLazyGetSalesPayoutStatisticsQuery();
  const { data: trendingRestaurants, isLoading: isLoadingRestaurants } = useGetTrendingRestaurantsQuery();
  const { data: trendingCarts, isLoading: isLoadingCarts } = useGetTrendingCartsQuery();

  const datePickerRef = useRef<HTMLDivElement>(null);

  const handleClick = () => {
    setOpenDate((prevOpenDate) => !prevOpenDate);
  };


  const handleChange = (ranges: any) => {
    setDate(ranges.selection);

    const startDate = new Date(ranges.selection.startDate);
    const endDate = new Date(ranges.selection.endDate);

    const isSameDay = date.startDate.getTime() === date.endDate.getTime();

    if (isSameDay) {
      startDate.setUTCHours(0, 0, 0, 0);
    } else {
      startDate.setUTCHours(0, 0, 0, 0);
      startDate.setUTCDate(startDate.getUTCDate() + 1);
    }
    endDate.setUTCHours(23, 59, 59, 999);

    fetchData({
      startTime: startDate.toISOString(),
      endTime: endDate.toISOString(),
    });
  };

  // Close date picker when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (datePickerRef.current && !datePickerRef.current.contains(event.target as Node)) {
        setOpenDate(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Fetch data for current day when the component mounts

  useEffect(() => {
    const startDate = new Date();
    startDate.setUTCHours(0, 0, 0, 0);

    const endDate = new Date();
    endDate.setUTCHours(23, 59, 59, 999);

    fetchData({
      startTime: startDate.toISOString(),
      endTime: endDate.toISOString(),
    });
  }, [fetchData]);


  // Placeholder for data in case the API is still loading or there's an error
  const paymentStatusData = data || {
    totalEarnings: "0",
    totalOrderCount: "0",
    totalPayoutsToCarts: "0",
    totalPayoutsToRestaurants: "0",
    totalSales: "0",
  };

  // Transform trending restaurants data for TopItemList
  const topRestaurantsList = trendingRestaurants?.map((restaurant, index) => ({
    id: index,
    name: restaurant?.displayName,
    owner: restaurant?.owner.userId,
    earnings: restaurant?.score,
    image: restaurant?.imageUrl,
  })) || [];

  const topCartsData = trendingCarts
    ? trendingCarts.map((cart) => ({
      id: cart?.id || "default-id",
      name: cart?.displayName || "Unknown Cart",
      owner: cart?.owner?.userId || "Unknown Owner",
      earnings: cart?.score || 0,
      image: cart?.imageUrl || "",
    }))
    : [];

  // Show initial loading state when all data is loading
  const isInitialLoading = isLoadingStatistics && isLoadingRestaurants && isLoadingCarts;

  if (isInitialLoading) {
    return (
      // <div className="payouts-container">
      //   <BreadCrumbs hasSubMenus={true} />
      //   <div className="dashboard-initial-loading">
      //     <div className="loading-content">
      //       <div className="loading-icon-container">
      //         <div className="loading-circle"></div>
      //         <div className="loading-circle loading-circle-2"></div>
      //         <div className="loading-circle loading-circle-3"></div>
      //       </div>
      //       <h3>Loading Dashboard</h3>
      //       <p>Fetching your analytics data...</p>
      //       <div className="loading-progress">
      //         <div className="progress-bar">
      //           <div className="progress-fill"></div>
      //         </div>
      //         <div className="loading-steps">
      //           <span className="step active">Statistics</span>
      //           <span className="step active">Restaurants</span>
      //           <span className="step active">Carts</span>
      //         </div>
      //       </div>
      //     </div>
      //   </div>
      // </div>
      <div className="loading-container">
        <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '70vh' }}>
          <div className="text-center">
            <div className="loading-spinner mb-4">
              <Spinner
                animation="border"
                variant="primary"
                style={{
                  width: '4rem',
                  height: '4rem',
                  borderWidth: '4px',
                  color: '#3f0213'
                }}
              />
            </div>
            <h4 className="loading-title mb-3">Loading Dashboard</h4>
            <p className="dashboard-loading-text text-muted">
              Fetching your analytics data...
            </p>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div className="payouts-container">
      <BreadCrumbs hasSubMenus={true} />
      <div className="payouts-header">
        <h2 className="payouts-title">
          {PAYOUTS_PAYMENTS_NAME}
          {/* {isFetchingStatistics && (
            <FontAwesomeIcon icon={faSpinner} spin className="ms-2 text-primary" />
          )} */}
        </h2>
        <div className="payouts-content">
          <div className={`date-picker-container ${isFetchingStatistics ? 'date-picker-loading' : ''}`} ref={datePickerRef}>
            <input
              className="payouts-input"
              onClick={handleClick}
              disabled={isFetchingStatistics}
              placeholder={`${format(date.startDate, "MMM, dd, yyyy")} - ${format(date.endDate, "MMM, dd, yyyy")}`}
            />
            {openDate && !isFetchingStatistics && (
              <div className="date-picker-content">
                <div className="calendar-section">
                  <DateRangePicker
                    ranges={[date]}
                    onChange={handleChange}
                    className="dateRange"
                    inputRanges={[]}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Payment Status Boxes */}
      <div className="paymentStatusBoxStyling">
        {isLoadingStatistics || isFetchingStatistics ? (
          // Enhanced loading skeleton for payment status boxes
          <>
            {[
              { title: "Total Earnings", delay: "0s" },
              { title: "Total Orders", delay: "0.1s" },
              { title: "Total Payouts to Carts", delay: "0.2s" },
              { title: "Total Payouts to Restaurants", delay: "0.3s" },
              { title: "Total Sales", delay: "0.4s" }
            ].map((item, index) => (
              <div key={index} className="payment-status-skeleton" style={{ animationDelay: item.delay }}>
                <div className="skeleton-header">
                  <div className="skeleton-icon"></div>
                  <div className="skeleton-title"></div>
                </div>
                <div className="skeleton-value-container">
                  <div className="skeleton-value"></div>
                  <div className="skeleton-subvalue"></div>
                </div>
                <div className="skeleton-chart"></div>
                <div className="loading-overlay">
                  <div className="loading-dot"></div>
                  <div className="loading-dot"></div>
                  <div className="loading-dot"></div>
                </div>
              </div>
            ))}
          </>
        ) : (
          <>
            <PaymentStatusBox title="Total Earnings" value={paymentStatusData.totalEarnings.toString()} percentage="" />
            <PaymentStatusBox title="Total Orders" value={paymentStatusData.totalOrderCount.toString()} percentage="" />
            <PaymentStatusBox title="Total Payouts to Carts" value={paymentStatusData.totalPayoutsToCarts.toString()} percentage="" />
            <PaymentStatusBox title="Total Payouts to Restaurants" value={paymentStatusData.totalPayoutsToRestaurants.toString()} percentage="" />
            <PaymentStatusBox title="Total Sales" value={paymentStatusData.totalSales.toString()} percentage="" />
          </>
        )}
      </div>
      <div className="top-items-container">
        {isLoadingCarts ? (
          <div className="top-items-loading-container">
            <div className="top-items-loading-header">
              <h4>Top Carts</h4>
              <div className="loading-badge">Loading...</div>
            </div>
            <div className="top-items-loading-content">
              <div className="loading-list">
                {[1, 2, 3, 4, 5].map((item, index) => (
                  <div key={index} className="loading-list-item" style={{ animationDelay: `${index * 0.1}s` }}>
                    <div className="loading-avatar"></div>
                    <div className="loading-details">
                      <div className="loading-name"></div>
                      <div className="loading-subtitle"></div>
                    </div>
                    <div className="loading-score"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <TopItemList title="Top Carts" items={topCartsData} />
        )}

        {isLoadingRestaurants ? (
          <div className="top-items-loading-container">
            <div className="top-items-loading-header">
              <h4>Top Restaurants</h4>
              <div className="loading-badge">Loading...</div>
            </div>
            <div className="top-items-loading-content">
              <div className="loading-list">
                {[1, 2, 3, 4, 5].map((item, index) => (
                  <div key={index} className="loading-list-item" style={{ animationDelay: `${index * 0.1}s` }}>
                    <div className="loading-avatar"></div>
                    <div className="loading-details">
                      <div className="loading-name"></div>
                      <div className="loading-subtitle"></div>
                    </div>
                    <div className="loading-score"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <TopItemList title="Top Restaurants" items={topRestaurantsList} />
        )}
      </div>
    </div>
  );
};

export default PaymentDashboard;
